module.exports = __webpack_public_path__ + "media/pages/Home/images/Product_MealBox-7a799c1a29f3572efea5fa25683c0aff.jpg";